export default __webpack_public_path__ + "static/media/logo.e272772d.svg";